var map = {
	"./Admins": "6271",
	"./Admins.vue": "6271",
	"./Classify": "0929",
	"./Classify.vue": "0929",
	"./Customer": "4848",
	"./Customer copy": "659e",
	"./Customer copy.vue": "659e",
	"./Customer.vue": "4848",
	"./Dashboard": "7277",
	"./Dashboard copy": "344e",
	"./Dashboard copy.vue": "344e",
	"./Dashboard.vue": "7277",
	"./Error": "dda8",
	"./Error.vue": "dda8",
	"./GoogleMaps": "a154",
	"./GoogleMaps.vue": "a154",
	"./Icons": "9cc6",
	"./Icons.vue": "9cc6",
	"./Login": "a55b",
	"./Login.vue": "a55b",
	"./Marketing": "b8fa",
	"./Marketing.vue": "b8fa",
	"./Notifications": "fda7",
	"./Notifications.vue": "fda7",
	"./RegularTables": "9ac1",
	"./RegularTables.vue": "9ac1",
	"./Report": "762c",
	"./Report copy": "8c96",
	"./Report copy 2": "379b",
	"./Report copy 2.vue": "379b",
	"./Report copy.vue": "8c96",
	"./Report.vue": "762c",
	"./Roles": "f50e",
	"./Roles.vue": "f50e",
	"./Typography": "547e",
	"./Typography.vue": "547e",
	"./UserProfile": "4a39",
	"./UserProfile copy": "8689",
	"./UserProfile copy.vue": "8689",
	"./UserProfile.vue": "4a39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b3b";